import { render } from "./brand-list.vue?vue&type=template&id=1aa5b404"
import script from "./brand-list.vue?vue&type=script&lang=js"
export * from "./brand-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__